import {authStore} from '@store/stores/auth-store';
import {BaseRequest} from '@configs/request';

interface ICompanyGoalsRequest extends BaseRequest {
  fetchTeamMemberGoals(filters: IFiltersTeamMemberGoals): Promise<any>;
  fetchWorkspaceGoals(filters: IFiltersTeamMemberGoals): Promise<any>;
}
export interface IFiltersTeamMemberGoals {
  manager?: string;
  member?: string;
  group?: string;
  starts?: string;
  name?: string;
  ends?: string;
  sortByUsers?: boolean;
}

export class CompanyGoalsRequestImpl
  extends BaseRequest
  implements ICompanyGoalsRequest {
  url: string = '/goals/active?include=assignee';

  async fetchWorkspaceGoals(filters: IFiltersTeamMemberGoals) {
    const params = new URLSearchParams({
      include: 'assignee',
      paginate: 'false',
    });
    if (filters.manager) params.set('manager', filters.manager);
    if (filters.member) params.set('user', filters.member);
    if (filters.group) params.set('group', filters.group);
    if (filters.name) params.set('name', filters.name);

    const {data: response} = await this.request.get(`/goals?${params}`, {
      headers: {
        Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
      },
      useCache: false,
    });

    return response;
  }

  async fetchTeamMemberGoals(filters: IFiltersTeamMemberGoals) {
    const {manager, member, group, starts, ends, name, sortByUsers} = filters;
    const accessUrl = `${this.url}&${manager ? `manager=${manager}` : ''}${
      member ? `&user=${member}` : ''
    }${member || manager ? '&' : ''}${
      group
        ? `group=${group}`
        : sortByUsers === false
        ? ''
        : '&sortByUsers=true&deep_fetch=true'
    }&paginate=false${starts ? `&startDate=${starts}` : ''}${
      ends ? `&endDate=${ends}` : ''
    }${name ? `&name=${encodeURIComponent(name)}` : ''}`;
    const {data: response} = await this.request.get(accessUrl, {
      headers: {
        Authorization: `Bearer ${authStore.auth?.tokens.access.token}`,
      },
      useCache: false,
    });

    return response;
  }
}
